<template>
  <v-row no-gutters class="pt-2 px-2 subtitle">
      <v-col v-for="(item, i) in report" :key="i-9999" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-img :src="item.src"></v-img>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3" v-html="item.title"></v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    data () {
      return {
          report: [
      {
          title: "Payment",
          value: "/payment",
          color: "#211C5B",
          src: "info/payment.png",
        },
        {
          title: "Income",
          value: "/income",
          color: "#211C5B",
          src: "info/income.png",
        },
        {
          title: "Expense",
          value: "/expense",
          color: "#211C5B",
          src: "info/expense.png",
        },
    ],
      }
    },
    mounted:function(){ },
    props: {},
    methods:{
      changeRouter:function(path){
          this.$router
          .push({
            path: path
          })
          .catch(() => {});
      }
    },
    watch:{
    }
  }
</script>
<style scoped>

</style>